import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { uid } from 'uid';
import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import axios from 'axios'
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../../../interfaces/api';
import { USER } from '../../../../interfaces/auth.interface';
import TextInput from '../../../form-controls/TextInput';
import Select from '../../../form-controls/Select';
import { BeatLoader } from '../../../Spinners/Spinner';
import { validatePhoneNumber } from '../../../../utils/phone.utils';
import FileUpload from '../../../form-controls/FileUpload';
import { DropZoneComponent } from '../../../DropzoneComponent/DropzoneComponent';
import OutboundShipmentContext from '../../../../context/OutboundShipmentContext/OutboundShipmentContext';
import { OUTBOUND_SHIPMENT_ITEM } from '../../../../redux/thunks/interfaces/shipping.interface';



interface Props extends PropsFromRedux {
  shipmentItems: OUTBOUND_SHIPMENT_ITEM[];
  setShipmentItems: React.Dispatch<React.SetStateAction<OUTBOUND_SHIPMENT_ITEM[]>>;
}

interface Inputs {
    ItemName: string;
    Quantity : number;
    Value : number;
    Description : string;
    Image: string;
    Weight : number;
    Length : number;
    Width : number;
    Height : number;
  }

  const schema = yup.object().shape({
    ItemName: yup.string(),
    Quantity: yup.number(),
    Value: yup.number(),
    Description: yup.string(),
    Image: yup.string(),
    Weight : yup.number(),
    Length : yup.number(),
    Width : yup.number(),
    Height : yup.number()
  });


  export const EditNonDocumentItem: React.FC<Props> = ({
    resetApi,
    showModal,
    hideModal,
    getShipmentRate,
    shipmentRateState,
    modal
  }) => {
  
    const modalProps = modal?.ownProps?.editItem;
  
 

    React.useEffect(
      () => () => {
        resetApi(API_KEYS.GET_INTERNATIONAL_SHIPMENTS_RATE);
      },
      [resetApi]
    );

    const closeModal = () => {
        hideModal();
    };

    
    const  { outboundData, setOutboundData} = useContext(OutboundShipmentContext);
    const [setItem, setItemValues] = React.useState<any>(outboundData.shipmentItems);
    const [arrayValue, setArrayValue] = React.useState<any>([]);

    const deleteItem = (itemId: string) => {
      outboundData.shipmentItems.filter((item : any) => item.itemId !== itemId)
    };
    
    outboundData.shipmentItems = setItem;
    setOutboundData(outboundData);

    const onSubmit = (data: Inputs) => {
      const shipmentData = outboundData;
    //   const ItemDetails : any = {
    //     Quantity : data.Quantity,
    //     SpecialPackageId : 21,
    //     Value : data.Value,
    //     itemId: uid(8),
    //     Description : data.Description,
    //     internationalShipmentItemCategory : 0,
    //     ShipmentType : "Special",
    //     ImageUrl : data.Image,
    //     Weight : data.Weight,
    //     Length : data.Length,
    //     Width : data.Weight,
    //     Height : data.Height
  
    // }


    setItemValues(setItem.map((item : any) => {
      if(item.itemId == modalProps.itemId){
        return {...item,  Quantity : data.Quantity,
          SpecialPackageId : 21,
          Value : data.Value,
          itemId: uid(8),
          Description : data.Description,
          internationalShipmentItemCategory : 0,
          ShipmentType : "Special",
          ImageUrl : data.Image,
          Weight : data.Weight,
          Length : data.Length,
          Width : data.Width,
          Height : data.Height}
      };
      return item;
    })
    );
  
    const getPriceObj =  {
      receiverName: shipmentData.receiverName,
      receiverCompanyName: "GIG Logistics",
      receiverPhoneNumber: shipmentData.receiverPhoneNumber,
      receiverEmail: shipmentData.receiverEmail,
      receiverAddress: shipmentData.receiverAddress,
      receiverCity: shipmentData.receiverCity,
      receiverState: shipmentData.receiverState,
      receiverCountry: shipmentData.receiverCountry,
      receiverPostalCode: shipmentData.receiverPostalCode,
      receiverStateOrProvinceCode: shipmentData.receiverStateOrProvinceCode,
      receiverCountryCode: shipmentData.receiverCountryCode,
      shipmentItems: shipmentData.shipmentItems,
      VehicleType: shipmentData.VehicleType,
      isdeclaredVal: true,
      declarationOfValueCheck: data.Value,
      description: "",
      reprintCounterStatus: false,
      departureCountryId: 1,
      destinationCountryId: shipmentData.destinationCountryId,
      packageOptionIds: [
          19
      ],
      itemDetails: "",
      manufacturerCountry: "NG"
    }

    getShipmentRate(getPriceObj);
  
     }
    
    const history = useHistory();

      React.useEffect(() => {
        if(shipmentRateState?.success && shipmentRateState?.response?.Object){
          const savedDetails = outboundData;
          savedDetails.PriceDetails = shipmentRateState?.response?.Object?.[0];
          setOutboundData(savedDetails);
          hideModal();
          history.push('/outbound-details');
        }
    },[shipmentRateState?.success, shipmentRateState?.response?.Object]);

    const { handleSubmit, control, errors, reset, watch,register, setValue } = useForm<Inputs>({
        resolver: yupResolver(schema),
        defaultValues: modalProps
        
    });

    return(
        <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full px-2 bg-white lg:px-24 py-10 relative">
           <button type="button" aria-label="Close" onClick={closeModal}>
            <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
          </button>
                <h2 className="font-bold mb-4 text-xl text-center my-6 mb-8">Item details</h2>
                {/* <div className="w-full mx-auto bg-gray-300  rounded-md my-6 flex justify-between">
                    <div className="p-2 text-center w-2/4 bg-white font-medium round-md m-1">Document</div>
                  <Link
                    className="p-2 text-center w-2/4 pointer-events-auto hover:bg-white round-md m-1"
                    to={{ pathname: '/outbound-shipment/nondocument-item' }}
                    >
                      Non-document
                  </Link>
                </div> */}
                <div className="mb-5 text-sm text-gray-500 font-medium">
                <Controller
                    name="ItemName"
                    control={control}
                    defaultValue=""
                    render={({ name, value, onChange }) => (
                    <TextInput
                        name={name}
                        value={value}
                        className="border-gray-300 border p-3 w-full rounded-md"
                        id={name}
                        labelClassName="mb-2 flex "
                        label="Item Name:"
                        type="string"
                        wrapperClassName="w-full"
                        error={errors['ItemName']}
                        placeholder="ItemName"
                        customChange={onChange}
                    />
                    )}
                />
              </div>

              <div className="w-full bg-white my-4 flex justify-between">
          <Controller
            name="Length"
            control={control}
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-2 w-full rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                label="Length"
                type="number"
                wrapperClassName="w-full"
                // error={errors['Body']}
                placeholder="10cm"
                customChange={onChange}
                
              />
            )}
          />
           <Controller
            name="Width"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-2 ml-1 w-full rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                label="Width"
                type="number"
                wrapperClassName="w-full"
                error={errors['Width']}
                placeholder="10kg"
                customChange={onChange}
              />
            )}
          />

        <Controller
            name="Height"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-2 ml-2 w-full rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                label="Height"
                type="number"
                wrapperClassName="w-full"
                // error={errors['Body']}
                placeholder="12cm"
                customChange={onChange}
              />
            )}
          />
      
          </div>
            
          <div className="w-full bg-white my-4 flex justify-between">

          <Controller
            name="Quantity"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-2  w-full rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                label="Quantity"
                type="number"
                wrapperClassName="w-full"
                error={errors['Quantity']}
                placeholder="Quantity"
                customChange={onChange}
              />
            )}
          /> 
          <Controller
            name="Weight"
            control={control}
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border ml-1 p-2 w-full rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                label="Weight"
                type="number"
                wrapperClassName="w-full"
                error={errors['Weight']}
                placeholder="Weight"
                customChange={onChange}
                
              />
            )}
          />
      

        <Controller
            name="Value"
            control={control}
            defaultValue=""
            render={({ name, value, onChange }) => (
              <TextInput
                name={name}
                value={value}
                className="border-gray-300 border p-2 ml-2 w-full rounded"
                id={name}
                labelClassName="mb-2 flex text-sm text-gray-500 font-medium"
                label="Value"
                type="number"
                wrapperClassName="w-full"
                // error={errors['Body']}
                placeholder="Value"
                customChange={onChange}
              />
            )}
          />
      
          </div>
          <div className="mb-5 text-sm text-gray-500 font-medium">
          <Controller
                    name="Description"
                    control={control}
                    defaultValue=""
                    render={({ name, value, onChange }) => (
                    <TextInput
                        name={name}
                        value={value}
                        className="border-gray-300 border p-3 w-full rounded-md"
                        id={name}
                        labelClassName="mb-2 flex "
                        label="Shipment description"
                        type="string"
                        wrapperClassName="w-full"
                        error={errors['Description']}
                        placeholder="Describe your shipment"
                        customChange={onChange}
                    />
                    )}
                />
              </div>
          <div className="w-full flex">
              <Controller
                name="Image"
                control={control}
                defaultValue=""
                render={({ name, value, onChange }) => (
                  <FileUpload
                    wrapperClassName="w-full"
                    labelClassName="mb-2 ml-1 flex text-sm text-gray-500 font-medium"
                    label="Upload image"
                    name={name}
                    id={name}
                    value={value}
                    maxFiles={1}
                    fileProps={value}
                    customChange={(files: string[]) => {
                      onChange(files[0] || '');
                    }}
                    error={errors['Image']}
                    accept="image/*"
                    DropZoneComponent={DropZoneComponent}
                  />
                )}
              />
            </div>

          <div className="flex w-full justify-center">
          <button
          className="w-full bg-secondary my-10 font-semibold text-sm rounded text-white py-4"
          type="submit"
          disabled={shipmentRateState?.loading}
          >
            {/* Proceed to Pay */}
           {shipmentRateState?.loading ? <BeatLoader color="white" /> : 'Update Item'}
        </button>
    
        </div>
          </div>
        </form>
    );
                
}

